import { motion } from "framer-motion";
import { cn } from "../../utils/cn";
import Magnetic from "./Magnetic";

const Button = ({ 
  children, 
  variant = "outline", 
  size = "md",
  className = "",
  href,
  onClick,
  magnetic = true,
  ...props 
}) => {
  const baseClasses = "inline-block font-mono rounded transition-all duration-300 text-center interactive";
  
  const variants = {
    outline: "border border-accent text-accent hover:bg-accent/10",
    filled: "bg-accent text-navy hover:bg-accentHover",
    ghost: "text-accent hover:bg-accent/10",
  };

  const sizes = {
    sm: "px-4 py-2 text-xs",
    md: "px-6 py-3 text-sm",
    lg: "px-7 py-4 text-sm lg:px-8 lg:py-5",
  };

  const classes = cn(
    baseClasses,
    variants[variant],
    sizes[size],
    className
  );

  const MotionComponent = motion[href ? 'a' : 'button'];

  const ButtonElement = (
    <MotionComponent
      href={href}
      onClick={onClick}
      className={classes}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.98 }}
      target={href ? "_blank" : undefined}
      rel={href ? "noopener noreferrer" : undefined}
      {...props}
    >
      {children}
    </MotionComponent>
  );

  if (magnetic) {
    return (
      <Magnetic strength={0.15}>
        {ButtonElement}
      </Magnetic>
    );
  }

  return ButtonElement;
};

export default Button;